/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { m } from 'motion/react'
import sendPosthogEvent from '@web/utils/send-posthog-event'
import { useState } from 'react'
import { SubmissionProps } from '..'
import SubmitMessage from '../submit-message'
import { MarketoForm } from 'components/marketo-form/form'
import s from './styles.module.css'

export const Submit = () => {
	const [submission, setSubmission] = useState<SubmissionProps | null>(null)

	const onSubmitSuccess = (data, response) => {
		setSubmission({
			submitStatus: 'success',
			lead: {
				// * TODO Replace with the below line once we're able to get this form ID without needing the response
				// * If not, perhaps we transition to just using the email for lead ID-ing?
				// * Ref: https://nation.marketo.com/t5/product-discussions/forms-api-update-by-lead-id/td-p/77472
				// id: response.result[0].id,
				id: 34721779,
				email: 'Email' in data ? (data.Email as string) : '',
			},
		})
		sendPosthogEvent('Newsletter Signup', { placement: 'footer' })
	}

	const onSubmitError = () => {
		setSubmission({
			submitStatus: 'error',
		})
	}

	return (
		<>
			{submission && (
				<m.div
					className={s.submissionStatus}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.3, delay: 0.2 }}
				>
					<SubmitMessage {...submission} />
				</m.div>
			)}
			<m.div
				inert={submission && true}
				animate={{ opacity: submission ? 0 : 1 }}
				transition={{ duration: 0.3 }}
			>
				<MarketoForm
					formId="2459"
					submitTitle="Subscribe"
					className={s.form}
					onSubmitSuccess={onSubmitSuccess}
					onSubmitError={onSubmitError}
					persistFieldValues={false}
					formName="Sign up for HashiCorp news"
					allowBadges={false}
					placeholderSize="sm"
				/>
			</m.div>
		</>
	)
}
